import { useCallback, useEffect, useState } from "react";
import IndiaDataGrid from "../../include/IndiaDataGrid";
import { Box, Button, MenuItem, TextField } from "@mui/material";

import { toast } from "react-toastify";
import { adminPost } from "./adminApi";
import { consoleColors, gridSx, primaryButtonSx } from "./consoleTheme";

const columnSets = {
  coupons: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "offer_title", headerName: "Coupon", flex: 1.3, minWidth: 160 },
    { field: "coupon_coin", headerName: "Value", width: 90 },
    { field: "coupon_issued", headerName: "Issued", width: 90 },
    { field: "max_coupon", headerName: "Max", width: 80 },
    { field: "min_order_amount", headerName: "Min order", width: 110 },
    { field: "offer_active", headerName: "Active", width: 120 },
    { field: "offer_expire", headerName: "Expiry", width: 120 },
    { field: "date_added", headerName: "Added", flex: 1, minWidth: 150 },
  ],
  luckydraw: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "customer_name", headerName: "Customer", flex: 1, minWidth: 140 },
    { field: "customer_mobile", headerName: "Mobile", width: 130 },
    { field: "customer_email", headerName: "Email", flex: 1, minWidth: 160 },
    { field: "order_amount", headerName: "Order", width: 100 },
    { field: "coupon_code", headerName: "Draw code", width: 120 },
    { field: "date_added", headerName: "Date", flex: 1, minWidth: 150 },
  ],
  customers: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "customer_name", headerName: "Customer", flex: 1, minWidth: 140 },
    { field: "cust_type", headerName: "Type", width: 110 },
    { field: "customer_mobile", headerName: "Mobile", width: 130 },
    { field: "customer_email", headerName: "Email", flex: 1, minWidth: 160 },
    { field: "total_visit", headerName: "Visits", width: 90 },
    { field: "order_amount", headerName: "Spend", width: 100 },
    { field: "loyalty_point", headerName: "Cashi coin", width: 110 },
  ],
  issued: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "offer_title", headerName: "Coupon", flex: 1.2, minWidth: 150 },
    { field: "cust_name", headerName: "Customer", flex: 1, minWidth: 140 },
    { field: "cust_mobile", headerName: "Mobile", width: 130 },
    { field: "coupon_active", headerName: "Issued", width: 120 },
    { field: "coupon_expire", headerName: "Expiry", width: 120 },
  ],
  redeemed: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "offer_title", headerName: "Coupon", flex: 1.2, minWidth: 150 },
    { field: "cust_name", headerName: "Customer", flex: 1, minWidth: 140 },
    { field: "cust_mobile", headerName: "Mobile", width: 130 },
    { field: "genereate_date", headerName: "Issued", width: 120 },
    { field: "redeem_date", headerName: "Redeemed", width: 120 },
  ],
  sales: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "customer_name", headerName: "Customer", flex: 1, minWidth: 140 },
    { field: "customer_mobile", headerName: "Mobile", width: 130 },
    { field: "order_amount", headerName: "Amount", width: 110 },
    { field: "payment_type", headerName: "Payment", width: 110 },
    { field: "points_earned", headerName: "Points in", width: 100 },
    { field: "points_redeemed", headerName: "Points out", width: 110 },
    { field: "date_added", headerName: "Date", flex: 1, minWidth: 150 },
  ],
  cards: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "card_type_name", headerName: "Card type", width: 130 },
    { field: "card_token", headerName: "Card number", flex: 1, minWidth: 130 },
    { field: "customer_name", headerName: "Customer", flex: 1, minWidth: 140 },
    { field: "customer_mobile", headerName: "Mobile", width: 130 },
    { field: "date_added", headerName: "Issued", flex: 1, minWidth: 150 },
  ],
  reviews: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "name", headerName: "Name", flex: 1, minWidth: 130 },
    { field: "mobile", headerName: "Mobile", width: 130 },
    { field: "shopping_rating", headerName: "Shopping", width: 100 },
    { field: "product_rating", headerName: "Product", width: 100 },
    { field: "staff_rating", headerName: "Staff", width: 90 },
    { field: "comment", headerName: "Comment", flex: 1.4, minWidth: 180 },
    { field: "date_added", headerName: "Date", flex: 1, minWidth: 150 },
  ],
  wallet: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "opening_balance", headerName: "Opening", width: 110 },
    { field: "wallet_action", headerName: "Type", width: 90 },
    { field: "wallet_amount", headerName: "Amount", width: 100 },
    { field: "closing_balance", headerName: "Closing", width: 110 },
    { field: "comment", headerName: "Remarks", flex: 1.4, minWidth: 180 },
    { field: "date_added", headerName: "Date", flex: 1, minWidth: 150 },
  ],
  qrcodes: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "qrcode_number", headerName: "QR", flex: 1, minWidth: 140 },
    { field: "gen_lot_number", headerName: "Lot", width: 90 },
    { field: "loading_number", headerName: "Load no.", width: 100 },
    { field: "amount", headerName: "Amount", width: 90 },
    { field: "qrcode_status_name", headerName: "Status", width: 120 },
    { field: "redeem_status", headerName: "Redeemed", width: 110, valueGetter: (value) => (String(value) === "1" ? "Yes" : "No") },
    { field: "date_added", headerName: "Date", flex: 1, minWidth: 150 },
  ],
  qrredeem: [
    { field: "store_name", headerName: "Store", flex: 1, minWidth: 140 },
    { field: "qrcode_number", headerName: "QR", flex: 1, minWidth: 140 },
    { field: "amount", headerName: "Amount", width: 90 },
    { field: "cust_name", headerName: "Customer", flex: 1, minWidth: 140 },
    { field: "cust_mobile", headerName: "Mobile", width: 130 },
    { field: "payment_flag_name", headerName: "Payment", width: 110 },
    { field: "redeem_date", headerName: "Redeemed", width: 120 },
  ],
};

export default function AdminListPage({ mod, kind, extra = {} }) {
  const [rows, setRows] = useState([]);
  const [stores, setStores] = useState([]);
  const [storeId, setStoreId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    adminPost("ADMIN_STORE_LIST").then((result) => {
      if (result.status === "200") setStores(result.data || []);
    });
  }, []);

  const extraKey = JSON.stringify(extra);
  const load = useCallback(async () => {
    const result = await adminPost(mod, { store_id: storeId, startDate, endDate, start: 0, limit: 300, ...JSON.parse(extraKey) });
    if (result.status === "200" && Array.isArray(result.data)) setRows(result.data);
    else toast.error(result?.status_message || "Could not load records");
  }, [mod, storeId, startDate, endDate, extraKey]);

  useEffect(() => { load(); }, [load]);

  const toggleCoupon = async (row) => {
    const status = String(row.status) === "1" ? "0" : "1";
    const result = await adminPost("ADMIN_COUPON_STATUS", { store_id: row.store_id, offer_id: row.offer_id, status });
    if (result.status === "200") {
      toast.success(result.data.message);
      setRows((prev) => prev.map((item) => (item.offer_id === row.offer_id ? { ...item, status } : item)));
    } else {
      toast.error(result?.status_message || "Update failed");
    }
  };

  const columns = [...(columnSets[kind] || [])];
  if (kind === "coupons") {
    columns.push({
      field: "status",
      headerName: "Status",
      width: 130,
      renderCell: (params) => (
        <Button size="small" variant="contained" color={String(params.row.status) === "1" ? "success" : "warning"} onClick={() => toggleCoupon(params.row)}>
          {String(params.row.status) === "1" ? "Enabled" : "Disabled"}
        </Button>
      ),
    });
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap", alignItems: "center", background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 2.5, p: 1.5 }}>
        <TextField select size="small" label="Store" value={storeId} onChange={(e) => setStoreId(e.target.value)} sx={{ minWidth: 220 }}>
          <MenuItem value="">All stores</MenuItem>
          {stores.map((store) => <MenuItem key={store.store_id} value={store.store_id}>{store.store_name}</MenuItem>)}
        </TextField>
        <TextField size="small" type="date" label="From" InputLabelProps={{ shrink: true }} value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        <TextField size="small" type="date" label="To" InputLabelProps={{ shrink: true }} value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        <Button variant="contained" onClick={load} sx={primaryButtonSx}>Apply</Button>
      </Box>
      <Box sx={{ height: 640, background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 2.5, overflow: "hidden" }}>
        <IndiaDataGrid
          rows={rows.map((row, index) => ({ ...row, id: row.row_temp_id || row.offer_id || row.code_id || index }))}
          columns={columns}
          disableRowSelectionOnClick
          pageSizeOptions={[10, 25, 50, 100]}
          initialState={{ pagination: { paginationModel: { pageSize: 10, page: 0 } } }}
          sx={gridSx}
        />
      </Box>
    </Box>
  );
}
